import { render, staticRenderFns } from "./approval-xiangqing.vue?vue&type=template&id=2c7fad0b&scoped=true&"
import script from "./approval-xiangqing.vue?vue&type=script&lang=js&"
export * from "./approval-xiangqing.vue?vue&type=script&lang=js&"
import style0 from "./approval-xiangqing.vue?vue&type=style&index=0&id=2c7fad0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7fad0b",
  null
  
)

export default component.exports